import React from 'react';

import { useSelector } from 'react-redux';

import { CurrentlyPlaying } from 'components/ConnectedAudioPlayer/hls-helper';

import { useAlgolia } from 'hooks/useAlgolia';
import { useAuth } from 'hooks/useAuth';

import { PlayerState } from 'store/modules/player';
import { ProfileState } from 'store/modules/profile';

interface State {
  profile: ProfileState;
  player: PlayerState;
}

export const usePlaybackTracking = () => {
  const [eventSent, setEventSent] = React.useState(false);
  const { sendConvertedObjectIDsAfterSearch } = useAlgolia();

  const { user } = useAuth();

  const currentlyPlaying = useSelector<State, CurrentlyPlaying | undefined>(
    ({ player }) => player.currentlyPlaying,
  );

  const percentageComplete = useSelector<State, number | undefined>(
    ({ player }) => player.percentageComplete,
  );

  React.useEffect(() => {
    setEventSent(false);
  }, [currentlyPlaying?.id]);

  React.useEffect(() => {
    if (
      currentlyPlaying?.algoliaSource &&
      !eventSent &&
      percentageComplete &&
      percentageComplete >= 50
    ) {
      sendConvertedObjectIDsAfterSearch({
        eventName: 'story_played_50_percent_conversion',
        objectId: currentlyPlaying.algoliaSource.objectID,
        index: currentlyPlaying.algoliaSource.index,
        userToken: user?.trackingId,
        queryID: currentlyPlaying.algoliaSource.queryID,
      });
      setEventSent(true);
    }
  }, [
    currentlyPlaying,
    eventSent,
    percentageComplete,
    sendConvertedObjectIDsAfterSearch,
    user?.trackingId,
  ]);
};
